import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg"
}
const _hoisted_2 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "text-sm text-gray-700" }
const _hoisted_6 = { class: "block sm:inline" }
const _hoisted_7 = { class: "flex items-center gap-3 flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-up" }, {
    default: _withCtx(() => [
      (_ctx.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-semibold" }, "We use cookies", -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "hidden sm:inline" }, " - ", -1)),
                    _createElementVNode("span", _hoisted_6, [
                      _cache[3] || (_cache[3] = _createTextVNode(" This website uses cookies to enhance user experience and analytics. By continuing to use this site, you agree to our ", -1)),
                      _createElementVNode("a", {
                        href: "#",
                        class: "text-green-600 hover:text-green-700 underline font-medium",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openPrivacyPolicy && _ctx.openPrivacyPolicy(...args)), ["prevent"]))
                      }, " Privacy Policy "),
                      _cache[4] || (_cache[4] = _createTextVNode(" . ", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.acceptCookies && _ctx.acceptCookies(...args))),
                    class: "btn-primary text-sm whitespace-nowrap"
                  }, " Accept "),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.declineCookies && _ctx.declineCookies(...args))),
                    class: "btn-secondary text-sm whitespace-nowrap"
                  }, " Decline ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}